{{ 'Project::GenerativeQuestionAnsweringTrainingFailed' | abpLocalization: notification.name }}
